import { gql } from '@apollo/client'
import { USER_FRAGMENT } from './UserFragment'

export const PLANOGRAM_FEEDBACK_IMAGES_ISSUES_FRAGMENT = gql`
  fragment PlanogramFeedbackImagesIssues on PlanogramSegmentFlaggedIssueImage {
    id
    created
    bucketFileName
    url
    displaySegment {
      created
      modified
      segmentNumber
      id
      planogram {
        id
        display {
          id
          shortDescription
          displayType
          store {
            id
            address {
              id
              address1
              address2
              city
              state
              postalCode
            }
            store {
              name
              address {
                id
                address1
                address2
                city
                state
                postalCode
              }
              id
            }
          }
        }
      }
    }
    flaggedReason {
      id
      reason
      issueTypes
      resolved
      reasonBy {
        ...User
      }
    }
  }
  ${USER_FRAGMENT}
`
